import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root'
})

export class LangService {
  private _langage: string = 'es';
  private _langages: string[] = undefined;
  private _domainId = environment.domainId;

  public langNames = {
    es: "Español",
    en: "Inglés"
  }
  

  get langage(){
    return this._langage;
  }

  set langage(value){
    this._langage = value;
  }

  get langages(){
    return this._langages;
  }

  set langages(value){
    this._langages = value;
  }

  constructor(
    private translateService: TranslateService,
    private httpSv: HttpService,
  ) {
  }

  async initLanguage(){
    try{

      const availableLangs: any[] = await this.httpSv.itemIndex('client', '', '', 'translate');
      const mappedLangs = availableLangs.map(x => x.name);
      const addLangs = mappedLangs.length ? mappedLangs : ['es', 'en'];
      this.translateService.addLangs(addLangs);
      const data = await this.httpSv.getParam('lang', this._domainId);
      const lang = data ? JSON.parse(data.value) : 'es';
      this.langages = this.translateService.getLangs();
      this.translateService.translations
      this.translateService.setDefaultLang(lang);
      this.translateService.use(lang);
      return true;
    }catch(err){
      console.error(err);
    }
  }

  async changeLangage(langage: string) {
    const useLangage = langage || 'es';
    this.translateService.use(useLangage);
    localStorage.setItem('langage', langage);
    this.langage = langage;
    await this.httpSv.itemAction({lang: langage}, 'auth', 'lang');
  }
}
